// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const CheckboxWrapper: StatelessFunctionalComponent<*> = styled.div`
  .Checkbox {
    &-icon {
      width: 20px;
      height: auto;
    }
  }
`;

export default CheckboxWrapper;
